import { render, staticRenderFns } from "./campaign-portal.vue?vue&type=template&id=87cf6cbe"
import script from "./campaign-portal.vue?vue&type=script&lang=ts"
export * from "./campaign-portal.vue?vue&type=script&lang=ts"
import style0 from "./campaign-portal.vue?vue&type=style&index=0&id=87cf6cbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports